import {useEffect, useState} from "react";
import {Card, Spinner} from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import currency from "currency.js";
import Button from "react-bootstrap/Button";
import SendPayment from "../../common/SendPayment";
import moment from "moment";
import AlertConfirmModal from "../../common/AlertConfirmModal";

const ManualPayouts = () => {

    const [payouts, setPayouts] = useState([]);
    const [filter, setFilter] = useState('unpaid');
    const [busy, setBusy] = useState(true);
    const [username, setUsername] = useState('');
    const [showPayment, setShowPayment] = useState(false);
    const [activeUser, setActiveUser] = useState({});
    const [alertText, setAlertText] = useState('');
    const [show, setShow] = useState(false);

    const handleSelectRow = (index) => {
        payouts[index].to_update = !payouts[index].to_update;
        setPayouts([...payouts]);
    }
    const getPayoutRequests = async () => {
        setBusy(true);
        await axios.post('/api/pu-payouts/manual-payouts', {filter: filter, username: username})
                    .then((response) => {
                        if(response.data.success) {
                            setPayouts(response.data.payouts);
                        }
                    })
                    .catch((error) => { console.log('Cannot fetch payout requests')})
                    .finally(() => {
                        setBusy(false);
                    });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        getPayoutRequests();
    }

    useEffect(() => {
        getPayoutRequests();
    }, [filter]);

    const handlePayment = (e) => {
        const selected = payouts.filter((payout) => payout.to_update);

        if (selected.length > 1) {
            setAlertText('Multiple selection not allowed');
            setShow(true);
            return;
        }
        if (selected.length === 0) {
            setAlertText('Please select a PU');
            setShow(true);
            return;
        }

        setShowPayment(true);
        setActiveUser({
            balance_owning_usd: selected[0].payout_fund,
            username: selected[0].login,
        });
    }

    const handleSuccess = () => {
        setShowPayment(false);
        getPayoutRequests();
    };

    const handleSearch = () => {
        getPayoutRequests();
    };

    useEffect(() => {
        if (alertText) {
            setShow(true);
        }
    }, [alertText]);

    const clearSearchText = () => {
        setUsername('');
    }

    return <>
        <AlertConfirmModal
            modalBody={alertText}
            show={show}
            setShow={setShow}
            isConfirm={false} />
        <div className={'row'}>
            <Card className="col-md-12 col-lg-8 mt-4">
                <Card.Header as="h6" className="bg-white font-weight-bold">
                    <div className={'row'}  style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div>Payout Requests</div>
                        <div>
                            <div className="form-check form-check-inline">
                                <input
                                    name="filterBy"
                                    className="form-check-input"
                                    type="radio"
                                    id="payoutFilter"
                                    value="all"
                                    onChange={() => setFilter('all')}
                                    checked={filter === 'all'}
                                    key={Math.random()}
                                />
                                <label className="form-check-label" htmlFor="searchByLogin">All</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    name="filterBy"
                                    className="form-check-input"
                                    type="radio"
                                    id="payoutFilter"
                                    value="unpaid"
                                    onChange={() => setFilter('unpaid')}
                                    checked={filter === 'unpaid'}
                                    key={Math.random()}
                                />
                                <label className="form-check-label" htmlFor="searchByLogin">Unpaid</label>
                            </div>
                        </div>
                    </div>

                </Card.Header>
                <Card.Body>
                    <div className={'d-flex flex-row'}>
                        <Form onSubmit={handleSubmit} inline>
                            <Form.Group>
                                <Form.Label htmlFor="username">
                                    Username
                                </Form.Label>
                                <Form.Control
                                    className={`mb-2 mr-sm-2 ${username ? 'mr-0' : 'mr-16p'}`}
                                    id="username"
                                    placeholder=""
                                    custom
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                                {
                                    username && <i className="fal fa-times search-clear-icon" onClick={clearSearchText} />
                                }
                            </Form.Group>
                            <Button
                                variant="primary"
                                disabled={busy}
                                onClick={handleSearch}
                                className="mt-2 ml-2"
                            >
                                {busy ? "Searching..." : "Search User"}
                            </Button>
                            <Button type="button" className="mt-2 ml-2" onClick={handlePayment} disabled={busy || show}>
                                Add Payment
                            </Button>
                        </Form>
                    </div>
                    <div className="d-flex flex-row mt-4" style={{minHeight: '200px', maxHeight: '600px', overflowY: 'scroll'}}>
                        <Table striped hover>
                            <thead>
                                <tr>
                                    <th style={{width: '10px'}}>#</th>
                                    <th style={{width: '150px'}}>Username</th>
                                    <th style={{width: '200px'}}>Request Date</th>
                                    <th style={{width: '40px'}}>Funds</th>
                                    <th style={{width: '200px'}}>Paid Date</th>
                                    <th style={{width: '40px'}}>Paid</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    busy ? <tr><td colSpan={6}><Spinner size="xs" animation="border" variant="primary" style={{ margin: '0 auto', padding: '0' }} /></td></tr>
                                    : <>
                                        {
                                            payouts && payouts.length > 0 ? payouts.map((payout, index) => {
                                                return <tr key={`${Math.random()*1000}`}>
                                                    <td onClick={e => e.stopPropagation()}>
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => handleSelectRow(index)}
                                                            checked={payout.to_update}
                                                            disabled={payout.paid_date !== null}
                                                        />
                                                    </td>
                                                    <td style={{textAlign: 'left'}}>{payout.login}</td>
                                                    <td style={{textAlign: 'left'}}>{moment(payout.req_date).format('lll')}</td>
                                                    <td style={{textAlign: 'right'}}>{currency(payout.myfund_balance).format()}</td>
                                                    <td style={{textAlign: 'left'}}>{payout.paid_date && moment(payout.paid_date).format('lll')}</td>
                                                    <td style={{textAlign: 'right'}}>{payout.paid_amount && currency(payout.paid_amount).format()}</td>
                                                </tr>
                                            })
                                            : <tr><td colSpan={6} style={{textAlign: 'center'}}>No Payout Request</td></tr>
                                        }
                                    </>
                                }
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>
        </div>

        {
            <SendPayment
                show={showPayment}
                setShow={setShowPayment}
                activeUser={activeUser}
                handleSuccess={handleSuccess}
            />
        }
    </>
}

export default ManualPayouts;
